import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueSession from "vue-session";
import vuetify from './plugins/vuetify';
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueGlobalVariable from "vue-global-var";
import VueClipboard from 'vue-clipboard2'
import CountryFlag from 'vue-country-flag'
import Vue2Editor from "vue2-editor";
import VueMultianalytics from 'vue-multianalytics'

Vue.use(Vue2Editor);
Vue.component('country-flag', CountryFlag)

Vue.config.productionTip = false
VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueSession);
Vue.use(VueAxios, axios);
Vue.use(VueClipboard);
Vue.use(VueGlobalVariable, {
  globals: {
    version:"1.2.1",
    base_url: 'https://kariba.autocarsgamon.com/API/',
    travel_url: 'https://kariba.autocarsgamon.com/viaje/'
  }
});
let mixpanelConfig = {
  token: 'c0fff9fdf560b41df4ef59dc7464d79a'
}
Vue.use(VueMultianalytics, {
  modules: {
    mixpanel: mixpanelConfig
  }
})
Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
